
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.868 20.162l-5.943-6.484a7.476 7.476 0 1 0-.737.677l5.943 6.483a.5.5 0 0 0 .738-.675zM1.997 8.499a6.5 6.5 0 1 1 6.5 6.5 6.508 6.508 0 0 1-6.5-6.5z","fill":"#0b0f4d","stroke":"#0b0f4d","stroke-width":"2"}})])
          )
        }
      }
    